import { ref } from "vue";
// import { usePersistentState } from "@/services/persistenceService";

export const eraserToolState = ref({
  radius: 30,
});
// usePersistentState("eraserToolState", eraserToolState);
